import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

type FeedbackPopupProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (comments: string) => void;
};

export default function FeedbackPopup({
  open,
  onClose,
  onSubmit,
}: FeedbackPopupProps) {
  const [comments, setComments] = useState("");

  const handleSubmit = () => {
    if (comments.trim()) {
      onSubmit(comments);
      setComments(""); // reset after submit
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 1.5 } }}
    >
      <DialogTitle sx={{ pb: 1.5 }}>We value your feedback</DialogTitle>

      <DialogContent>
        <TextField
          label="Your comments"
          multiline
          fullWidth
          minRows={4}
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          variant="outlined"
          margin="normal"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={!comments.trim()}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
